/**
 * Componente responsável por exibir a tela de convite novo quando o usuário não tem nenhum vínculo existente.
 * Apresenta a opção de aceitar ou recusar o convite de vinculação enviado por um profissional.
 */
import { faUserFriends } from "@fortawesome/free-solid-svg-icons";
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
import afinandinho_invite from "../../../../../assets/images/afinandinho_invite.svg";

/**
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.newParentUser - Dados do profissional que enviou o convite
 * @param {Function} props.confirmInvitation - Função chamada quando o usuário aceita o convite
 * @param {Function} props.rejectInvitation - Função chamada quando o usuário recusa o convite
 */
const NoLinkView = ({ newParentUser, confirmInvitation, rejectInvitation }) => {
  return (
    <StateView className={classes.inviteContainer}>
      {/* Título da tela de convite */}
      <H1 className={classes.inviteTitle}>Novo convite recebido!</H1>

      {/* Mensagem explicativa sobre o convite recebido */}
      <LinkMessage className={classes.inviteMessage}>
        <p>Você recebeu um convite para se vincular à <strong>{newParentUser?.given_name || "um profissional"}</strong>.</p>
        <p>Deseja aceitar este convite?</p>
      </LinkMessage>

      {/* Ícone ilustrativo do Afinandinho com envelope */}
      <StateIcon 
        imageSrc={afinandinho_invite}
        altText="Afinandinho com o ícone de email"
        iconContainerClass={classes.emailIconContainer}
      />

      {/* Botões de ação: aceitar ou recusar convite */}
      <div className={classes.buttonGroup}>
        {/* Botão para recusar o convite */}
        <RoundedButton
          className={classes.rejectButton}
          text="RECUSAR"
          onClick={rejectInvitation}
        />
        {/* Botão para aceitar o convite */}
        <RoundedButton
          className={classes.acceptButton}
          text="ACEITAR CONVITE"
          onClick={confirmInvitation}
        />
      </div>
    </StateView>
  );
};

export default NoLinkView;